module.exports = __webpack_public_path__ + "static/media/low_carb_2.7a85a68b.jpg";